import './TWUnfold.scss'
import { useState } from "react"
import { classify } from '../../../helpers'

const TWUnfold = ({ content, children, className = '' }) => {
	const [expanded, setExpanded] = useState(false)
	return (
		<div className={classify("tw-unfold", className)}>
			<div
				className={classify(
					"tw-unfold__content text-white p-3 lg:p-4 rounded overflow-hidden", {
					[content]: content,
					'tw-unfold__content-expanded': expanded
				})}
			>
				<p>{children}</p>
			</div>
			<button
				onClick={() => setExpanded(!expanded)}
				className="mt-2 font-bold text-primary"
			>
				{expanded ? "See Less" : "See More"}
			</button >
		</div >
	)
}

export default TWUnfold
